import Summary from './Summary';
import { withI18n } from 'react-i18next';
import {
  checkoutOrderConfirmedSel,
  placeOrderProgressSel
} from 'src/store/modules/checkout';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({
  orderplaced: checkoutOrderConfirmedSel(state),
  placingOrderInProgress: placeOrderProgressSel(state)
});

export const pureComponent = Summary;
export default connect(mapStateToProps, null)(withI18n()(Summary));
